import type { ReactNode } from "react";

import { SWReactIcons } from "@similarweb/icons";

import { SERP_MAP } from "app/pages/website-analysis/traffic-sources/search/components/serp/SerpTypes";

import { Box, SerpCount, SerpName } from "../../StyledComponents";
import type { ISERPRecord } from "../../types";

export const SerpTileContent = ({ children, serpName }: { children?: ReactNode; serpName: string }) => {
    return (
        <>
            <SWReactIcons
                iconName={SERP_MAP[serpName].icon}
                size={"xs"}
            />
            <div style={{ paddingLeft: "24px" }}>
                <SerpName>{SERP_MAP[serpName].name}</SerpName>
                {children}
            </div>
        </>
    );
};

export interface ISerpTileProps {
    serpFeature: ISERPRecord;
    isSelected: boolean;
    getSerpCountText: (serpName: string, serpFeaturesCount: number) => string;
    onTileClick: (serpName: string) => void;
}

export const SerpTile = ({ serpFeature, isSelected, getSerpCountText, onTileClick }: ISerpTileProps) => {
    const serpName = serpFeature.serpFeature;

    if (!serpFeature) {
        return null;
    }

    return (
        <Box
            onClick={() => onTileClick(serpName)}
            isSelected={isSelected}
        >
            <SerpTileContent serpName={serpName}>
                <SerpCount>{getSerpCountText(serpName, serpFeature.records.length)}</SerpCount>
            </SerpTileContent>
        </Box>
    );
};
